import { asyncRouterMap, constantRouterMap } from '@/config/router.config';
import cloneDeep from 'lodash.clonedeep';

// 角色定义
export const ROLES = {
  ADMIN: 'admin',
  CONTENT_MANAGER: 'content_manager',
  BLOGGER: 'blogger',
};

// 账号与角色映射
export const ACCOUNT_ROLE_MAP = {
  // 管理员
  'chloeyang0906@gmail.com': ROLES.ADMIN,
  'virgil1126@gmail.com': ROLES.ADMIN,
  'cxylys@163.com': ROLES.ADMIN,
  'yuanhouly@gmail.com': ROLES.ADMIN,
  // 内容管理员
  'nicole.poindeo@gmail.com': ROLES.CONTENT_MANAGER,
  // 博客写手
  'katiaevans107@gmail.com': ROLES.BLOGGER,
};

/**
 * 根据账号获取用户角色
 * @param {string} account 用户账号
 * @returns {string} 用户角色
 */
export function getRoleByAccount(account) {
  return ACCOUNT_ROLE_MAP[account] || ROLES.BLOGGER;
}

/**
 * 检查用户是否有权限访问该路由
 * @param {Array} routeRoles 路由所需角色
 * @param {string} userRole 用户角色
 * @returns {boolean}
 */
function hasPermission(routeRoles, userRole) {
  if (!routeRoles || routeRoles.length === 0) {
    return true;
  }
  return routeRoles.includes(userRole);
}

/**
 * 根据用户角色过滤路由
 * @param routerMap 路由配置
 * @param userRole 用户角色
 * @returns 过滤后的路由
 */
function filterAsyncRouter(routerMap, userRole) {
  return routerMap.filter((route) => {
    // 检查路由角色权限
    if (!hasPermission(route.meta?.roles, userRole)) {
      return false;
    }

    // 递归过滤子路由
    if (route.children?.length) {
      route.children = filterAsyncRouter(route.children, userRole);
    }

    return true;
  });
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
  },

  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },

  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        const { role } = data;
        console.log('用户角色:', role);

        const routerMap = cloneDeep(asyncRouterMap);
        const accessedRouters = filterAsyncRouter(routerMap, role);

        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    },
  },
};

export default permission;
